module.exports = __webpack_public_path__ + "img/wine_list.f09386be.png";